import React from 'react';
import InputField, { SelectOption, TextareaField, addOption } from '../../utils/InputField';
import { TextCapitalize } from '../../utils/TextFormatter';
import countryAr from '../../utils/country.json';

function AddressBody({ formData, onChange, editMode = false }) {
    return (
        <div className="address-form h-full flex flex-col gap-4">
            <div className="flex flex-row gap-4">
                <InputField
                    label="First Name"
                    name="firstName"
                    placeholder='Ex: "John"'
                    value={formData?.firstName}
                    formData={formData}
                    onChange={onChange}
                    required
                />
                <InputField
                    label="Last Name"
                    name="lastName"
                    placeholder='Ex: "Doe"'
                    value={formData?.lastName}
                    formData={formData}
                    onChange={onChange}
                    required
                />
            </div>
            <InputField
                label="Organization"
                name="organization"
                placeholder='Ex: "Organization"'
                value={formData?.organization}
                formData={formData}
                onChange={onChange}
                required
            />
            <div className="flex flex-row gap-4">
                <InputField
                    label="Email"
                    name="email"
                    placeholder="Ex: name@example.com"
                    value={formData?.email}
                    formData={formData}
                    onChange={onChange}
                    required
                />
                <InputField
                    label="Phone"
                    name="phone"
                    placeholder="Ex: +1 123 456 7890"
                    value={formData?.phone}
                    formData={formData}
                    onChange={onChange}
                    required
                />
            </div>
            <TextareaField
                label="Address"
                name="address"
                value={formData?.address}
                formData={formData}
                onChange={onChange}
                required
            />
            <div className="flex flex-row gap-x-4">
                <SelectOption
                    label="Country"
                    name="country"
                    value={formData?.country}
                    formData={formData}
                    onChange={onChange}
                    options={countryAr?.map(({ name, code }) => addOption(code, name, code))}
                    required
                />
                <InputField
                    label="State"
                    name="state"
                    value={formData?.state}
                    formData={formData}
                    onChange={onChange}
                    required
                />
            </div>
            <div className="h-16 flex flex-row gap-x-4">
                <InputField
                    label="City"
                    name="city"
                    value={formData?.city}
                    formData={formData}
                    onChange={onChange}
                    required
                />
                <InputField
                    label="ZIP"
                    name="zip"
                    value={formData.zip}
                    formData={formData}
                    onChange={onChange}
                    required
                />
            </div>
            {editMode && (
                <SelectOption
                    label="Status"
                    name="Status"
                    value={formData?.status}
                    formData={formData}
                    onChange={onChange}
                    options={['active', 'inactive']?.map((d) => addOption(d, TextCapitalize(d), d))}
                    required
                />
            )}
        </div>
    );
}

export default AddressBody;
